import logger from 'logger';

import { getAuthClient } from './clients';

/**
 * Requests a Devise password-reset email. The server intentionally returns 200
 * even when no user matches (anti-enumeration), so callers shouldn't try to
 * differentiate "email sent" vs "email not found." A non-2xx result here means
 * something unexpected went wrong (e.g. tenant resolution failed).
 */
export async function requestPasswordReset(input: {
  email: string;
}): Promise<{ ok: true } | { ok: false; reason: 'unknown' }> {
  const client = getAuthClient();
  try {
    await client.post('/forgot-password', { email: input.email });
    return { ok: true };
  } catch (err: any) {
    logger.error({
      msg: 'ForgotPasswordRequestFailed',
      noticable: err,
      extra: { context: { status: err?.response?.status } },
    });
    return { ok: false, reason: 'unknown' };
  }
}
